import PropTypes from 'prop-types'
import * as Sc from './Modal.style'
import Portal from 'components/Portal'

const Modal = ({ children, className, id, style }) => {
  return (
    <Portal id={id}>
      <Sc.Overlay data-testid={'overlay'}>
        <Sc.Content
          className={className}
          data-testid={'content'}
          style={{ ...style?.content }}
        >
          {children}
        </Sc.Content>
      </Sc.Overlay>
    </Portal>
  )
}

Modal.defaultProps = {
  className: null,
  style: { content: null },
}

Modal.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  id: PropTypes.string.isRequired,
  style: PropTypes.shape({
    content: PropTypes.shape({
      maxWidth: PropTypes.string,
    }),
  }),
}

export default Modal
